import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { DataService } from '../services/data.service';
import { ShareModule } from '../share.module';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '../../environment/environment';

@Component({
  selector: 'app-login',
  imports: [ShareModule, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  constructor(
    private msalService: MsalService,
    private dataService: DataService
  ) {}

  onLoginClick = async () => {
    try {
      // Ensure MSAL instance is initialized before calling any MSAL APIs
      await this.msalService.instance.initialize();

      this.msalService.instance.loginRedirect({
        redirectStartPage: environment.authClientConfiguration.redirect_url_login,
        scopes: ['User.Read'],
      });
    } catch (error) {
      console.error('Error initializing MSAL or during login redirect:', error);
    }
  };



}
